import { Injectable } from '@angular/core';
import { BaseService } from '../services/base.service';
import { components } from '../interfaces/swagger-types';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends BaseService {
  /** Step 1: validate credentials. Returns the 2FA-setup QR image, or an empty blob when 2FA is already set up. */
  async loginValidation(email: string, password: string): Promise<Blob | null> {
    return firstValueFrom(
      this.http
        .post('authentication/login-validation', { email, password }, { observe: 'response', responseType: 'blob' })
        .pipe(map((response) => response.body)),
    );
  }

  /** Step 2: complete login with the 2FA code. Returns the JWT. */
  async login2fa(email: string, password: string, verificationCode: string): Promise<string | null> {
    type LoginResponse = components['schemas']['JWTViewModel'];
    const response = await firstValueFrom(
      this.http.post<LoginResponse>('authentication/login-2fa', { email, password, verificationCode }),
    );
    return response?.jwt ?? null;
  }
}
